<template>
  <div class="comment-card">
    <div class="comment-header">
      <div class="comment-icon">
        <i class="el-icon-chat-dot-round"></i>
        <span>Commented</span>
        <span class="dot">•</span>
        <span class="author-wrapper">
          <span class="author-label">by</span>
          <el-avatar :size="16" class="author-avatar" style="font-size: 10px;">{{ comment.comment.postAuthor?.charAt(0) || 'U' }}</el-avatar>
          <span class="author-name">{{ comment.comment.postAuthor }}</span>
        </span>
        <span class="dot">•</span>
        <span class="timestamp">{{ formattedTimestamp }}</span>
      </div>
      <div class="comment-actions">
        <el-button
          type="text"
          size="mini"
          icon="el-icon-view"
          @click="viewPost"
          class="view-btn"
        >
          View Post
        </el-button>
        <el-dropdown trigger="click" @command="handleCommand">
          <el-button type="text" size="mini" class="more-btn">
            <i class="el-icon-more"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="remove">
              <i class="el-icon-delete"></i> Remove
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    
    <div class="comment-content">
      <div class="post-context">
        <h4 class="post-title" @click="viewPost">{{ comment.comment.postTitle }}</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommentCard',
  props: {
    comment: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedTimestamp() {
      const date = new Date(this.comment.timestamp)
      const now = new Date()
      const diffInHours = Math.floor((now - date) / (1000 * 60 * 60))
      
      if (diffInHours < 1) {
        return 'Just now'
      } else if (diffInHours < 24) {
        return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`
      } else {
        const diffInDays = Math.floor(diffInHours / 24)
        return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`
      }
    }
  },
  methods: {
    viewPost() {
      // Navigate to post detail page
      this.$router.push({
        path: '/stack',
        query: {
          id: this.comment.comment.postId,
          user_id: this.comment.comment.postAuthorId
        }
      })
    },
    handleCommand(command) {
      if (command === 'remove') {
        this.$emit('remove', this.comment.id)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.comment-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-left: 3px solid #1159AF;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #dee2e6;
  }
}

.comment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.comment-icon {
  display: flex;
  align-items: center;
  gap: 8px;

  i {
    font-size: 18px;
    color: #3498db;
  }

  > span {
    font-weight: 600;
    color: #495057;
    font-size: 14px;
  }

  .dot {
    color: #adb5bd;
    font-size: 14px;
    font-weight: normal;
  }

  .author-wrapper {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #6c757d;
    font-weight: normal;

    .author-label {
      font-size: 12px;
    }

    .author-avatar {
      flex-shrink: 0;
    }

    .author-name {
      font-size: 12px;
    }
  }

  .timestamp {
    font-size: 12px;
    color: #6c757d;
    font-weight: normal;
  }
}

.comment-actions {
  display: flex;
  gap: 8px;
  
  .view-btn {
    color: #1159AF;
    font-size: 12px;
    
    &:hover {
      color: #409EFF;
    }
  }
  
  .remove-btn {
    color: #6c757d;
    font-size: 12px;
    
    &:hover {
      color: #dc3545;
    }
  }
}

.comment-content {
  .post-context {
    margin-bottom: 12px;
    
    .post-title {
      font-size: 16px;
      font-weight: 600;
      color: #2c3e50;
      margin: 0 0 6px 0;
      cursor: pointer;
      line-height: 1.3;
      word-wrap: normal;
      word-break: normal;
      overflow-wrap: normal;
      hyphens: none;
      
      &:hover {
        color: #1159AF;
      }
    }
    
    .comment-meta {
      font-size: 12px;
      color: #6c757d;
    }
  }
  
  .comment-preview {
    background: #f8f9fa;
    border-radius: 6px;
    padding: 12px;
    border-left: 4px solid #3498db;
    
    .comment-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      
      .comment-label {
        font-size: 12px;
        font-weight: 600;
        color: #3498db;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
      
      .comment-stats {
        .likes {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 12px;
          color: #6c757d;
          
          i {
            color: #e74c3c;
            font-size: 12px;
          }
        }
      }
    }
    
    .comment-text {
      p {
        font-size: 14px;
        color: #495057;
        margin: 0;
        line-height: 1.5;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
}
</style> 